/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import {
  TilesGridLoadingCell,
  TilesGridCellCard,
} from '@bingads-webui-campaign-react/asset-library-components';

import { getFolderGridCellStyle } from './styles/folders-grid-cell-style';

const FoldersGridLoadingCell = ({
  onLoading,
  classes,
}) => (
  <TilesGridLoadingCell
    onLoading={onLoading}
    containerClass={classnames('tiles-grid-cell-content', classes.folderGridCellContainer)}
  >
    <TilesGridCellCard>
      <div className="folder-grid-loading-cell-content" />
    </TilesGridCellCard>
  </TilesGridLoadingCell>
);

FoldersGridLoadingCell.propTypes = {
  onLoading: PropTypes.func,
  // injected styles
  classes: PropTypes.shape({
    folderGridCellContainer: PropTypes.string,
  }).isRequired,
};

FoldersGridLoadingCell.defaultProps = {
  onLoading: null,
};

export const AssetLibraryFoldersGridLoadingCell
  = withDefaultStyles(FoldersGridLoadingCell, getFolderGridCellStyle);
